var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_normal"},[_c('label',{attrs:{"for":_vm.data.id},domProps:{"innerHTML":_vm._s(_vm.data.label)}}),_c('input',{attrs:{"type":_vm.data.type,"id":_vm.data.id,"placeholder":_vm.data.placeholder},domProps:{"value":_vm.data.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }